module.exports = __webpack_public_path__ + "static/media/img194.c53639d6.jpg";